import { useNewCatalogSignup } from '../plans/useNewCatalogSignup'
import { CatalogChoosePlan } from './CatalogChoosePlan'
import { LegacyChoosePlan } from './LegacyChoosePlan'
import { usePayrollPrices } from '@/features/payroll/payrollPrice.hooks'

/** Mounts neither screen until the flag resolves, since the legacy chooser forwards S corps and groups on mount. */
export const ChoosePlan = () => {
  const catalog = useNewCatalogSignup()
  usePayrollPrices()
  if (catalog === null) return null
  return catalog ? <CatalogChoosePlan /> : <LegacyChoosePlan />
}
